import { Component, OnInit, Inject, Output, EventEmitter } from '@angular/core';
import { LocalStorageService } from 'ngx-webstorage';
import {formatDate} from '@angular/common';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { NursingAssessmentEntryComponent } from '../nursing-assessment-entry/nursing-assessment-entry.component';
import { DatabankModel } from 'src/app/models/DataBankModel';
import { NurseAssessmentService } from 'src/app/services/NurseAssessmentService';
import { NurseAssessmentModel } from 'src/app/models/NurseAssessmentModel';
import { DoctorObservationComponent } from '../doctor-observation/doctor-observation.component';
import { ReservationVModel } from 'src/app/models/ReservationVModel';

@Component({
  selector: 'app-prog-steps',
  templateUrl: './prog-steps.component.html',
  styleUrls: ['./prog-steps.component.css']
})
export class ProgStepsComponent implements OnInit {
[x: string]: any;
  patientid = '';
  patientname = '';
  id =0;
  patdate = formatDate(new Date(), 'yyyy-MM-dd', 'en');
  @Output() submitClicked = new EventEmitter<any>();
  currentTime: string;
  wk_Detailes = '';
  visittype = '';
  HedenCreateFile = false;
  HedenTreatment = false;
  HedenTreatmentNurse = false;
  HedenObservation = false;
  HedenDocument = false;

  DisableCreateFile = false;
  DisableNursing = false;
  DisableObservation = false;
  DisablePreapartion = false;
  DisableDocument = false;
  DisablePreapartionNurse = false;
  DisableRoundandClinic = false;


  visitlocation = '';
   imagepath0 = 'assets/images/Worng.jpg';
   imagepath1 = 'assets/images/Worng.jpg';
   imagepath2 = 'assets/images/Worng.jpg';
   imagepath3 = 'assets/images/Worng.jpg';
   imagepath4 = 'assets/images/Worng.jpg';
    nursetime :any;
    pattime :any;
    trtime :any;
    doctime :any;
    attendtime : any;
    potime :any;


  constructor(public nurseassessmentService: NurseAssessmentService,
    private dialogref: MatDialog,public patientSelectedData : DatabankModel,
    public storage: LocalStorageService, @Inject(MAT_DIALOG_DATA) public data :any,)
    {
    this.patientid = data.patientid;
    this.patientname = data.patientname;
    this.patdate = formatDate(data.patdate, 'yyyy-MM-dd', 'en');
    this.wk_Detailes =this.patientid  + '- ' + this.patientname;
    this.visittype  = data.visittype;
    this.id = data.id;
    this.attendtime = formatDate(data.attendtime, 'hh:mm aa', 'en');
    this.updateTime();

  }
  updateTime() {
   const now = new Date();
   this.currentTime = now.toLocaleTimeString(); // Formats the time

 }

  ngOnInit(): void {
    if(this.patientid == '' || this.patientid == null || this.visittype == 'New Patient'){this.HedenCreateFile = false}else{this.HedenCreateFile = true};
    if(this.visittype == 'Treatment'   && this.storage.retrieve('stgGroup') !='7'){this.HedenTreatment = false;this.HedenTreatmentNurse = true};
    if(this.visittype == 'Treatment'   && this.storage.retrieve('stgGroup') =='7'){this.HedenTreatment = true;this.HedenTreatmentNurse = false;};

    this.RetriveNurseAssessment();
    this.RetrivePhycision();
    this.RetrivePersonal();
    this.RetriveDocument();
    this.RetrivePO();
    if(this.storage.retrieve('stgGroup') =='7'){
       this.DisableCreateFile = true;
       this.DisableNursing = false;
       this.DisableRoundandClinic = true ;
       this.DisableObservation = false;
       this.DisablePreapartion = true;
       this.DisableDocument = true;
       this.DisablePreapartionNurse = false;
       this.HedenTreatmentNurse = false;
       this.HedenTreatment = true;
     };
    if(this.storage.retrieve('stgGroup') =='2'){
      this.DisableCreateFile = true;
      this.DisableNursing = true;
             this.DisableRoundandClinic = true ;
      this.DisableObservation = false;
      this.DisablePreapartion = false;
      this.DisableDocument = false;
      this.HedenTreatmentNurse = true;
    };
    if(this.storage.retrieve('stgGroup') =='3'){
      this.DisableCreateFile = false;
      this.DisableNursing = true;
      this.DisableRoundandClinic = true ;
      this.DisableObservation = true;
      this.DisablePreapartion = true;
      this.DisableDocument = false;
      this.HedenTreatmentNurse = true;
    };
    if(this.storage.retrieve('stgGroup') =='4' ){
      this.DisableCreateFile = true;
      this.DisableNursing = true;
      this.DisableObservation = false;
      this.DisablePreapartion = false;
      this.DisableDocument = true;
      this.DisablePreapartionNurse =true;
      this.HedenTreatmentNurse = false;
      this.HedenTreatment = true;
      this.DisableRoundandClinic = false ;

      this.DisablePreapartionNurse = true;
      this.HedenTreatmentNurse = true;
      this.HedenTreatment = false;
    };
    if(this.storage.retrieve('stgGroup') =='8'){
      this.DisableCreateFile = false;
      this.DisableNursing = false;
      this.DisableObservation = false;
      this.DisablePreapartion = false;
      this.DisableDocument =false;
      this.DisablePreapartionNurse =false;
      this.HedenTreatmentNurse = false;
      this.DisableRoundandClinic = false ;
      this.HedenTreatment = false;
      this.HedenTreatmen = false
      this.DisablePreapartionNurse = true;
      this.HedenTreatmentNurse = true;
      this.HedenCreateFile = false;

    };
  }

  RetriveNurseAssessment(){
    if(this.patientid == '' || this.patientid == null ){return;}
      this.nurseassessmentService.GetProgressStep(this.patientid, this.patdate,'Nurse').subscribe({
      next: (data: NurseAssessmentModel) => {
        if(data.nursetime !=null){

        this.imagepath1 = 'assets/images/Right.jpg';
        this.visitlocation = data.visitlocation;
        this.nursetime = formatDate(data.nursetime, 'hh:mm aa', 'en');
//        console.log("this.nursetime:",this.nursetime,"--",this.trtime)
        }
      },
      complete: () => {
          if (!this.nursetime) {  // Check if visitlocation is undefined or null.  Could also check for an empty string "" if that's a possibility.
            this.imagepath1 = 'assets/images/Worng.jpg';
            this.nursetime = '';
          }
      }

    });

  }

  RetrivePhycision(){
    if(this.patientid == '' || this.patientid == null ){return;}
    this.nurseassessmentService.GetProgressStep(this.patientid, this.patdate,'Physicion').subscribe({
      next: (data: NurseAssessmentModel) => {
        if(data.nursetime !=null){
        this.imagepath2 = 'assets/images/Right.jpg';
        //this.visitlocation = data.visitlocation;
        this.trtime = formatDate(data.nursetime, 'hh:mm aa', 'en');
        console.log("this.nursetime1:",this.nursetime,"-1-",this.trtime)
        }
      },
      complete: () => {
          if (!this.trtime) {  // Check if visitlocation is undefined or null.  Could also check for an empty string "" if that's a possibility.
            this.imagepath2 = 'assets/images/Worng.jpg';
            this.trtime = '';
          }
      }
    });


  }
  RetrivePersonal(){
    if(this.patientid == '' || this.patientid == null){return;}

    this.nurseassessmentService.GetProgressStep(this.patientid, this.patdate,'Personal').subscribe({

      next: (data: NurseAssessmentModel) => {

        if(data.nursetime !=null){
        this.imagepath0 = 'assets/images/Right.jpg';
        //this.visitlocation = data.visitlocation;
        this.pattime = formatDate(data.nursetime, 'hh:mm aa', 'en');
       // console.log("this.nursetime1:",this.nursetime,"-1-",this.trtime)
        }
      },
      complete: () => {
          if (!this.pattime) {  // Check if visitlocation is undefined or null.  Could also check for an empty string "" if that's a possibility.
            this.imagepath0 = 'assets/images/Worng.jpg';
            this.pattime = '';
          }
      }
    });


  }
  RetriveDocument(){
    if(this.patientid == '' || this.patientid == null){return;}

    this.nurseassessmentService.GetProgressStep(this.patientid, this.patdate, 'Document').subscribe({

      next: (data: NurseAssessmentModel) => {

        if(data.nursetime !=null){
        this.imagepath3 = 'assets/images/Right.jpg';
        //this.visitlocation = data.visitlocation;
        this.doctime = formatDate(data.nursetime, 'hh:mm aa', 'en');
       // console.log("this.nursetime1:",this.nursetime,"-1-",this.trtime)
        }
      },
      complete: () => {
          if (!this.doctime) {  // Check if visitlocation is undefined or null.  Could also check for an empty string "" if that's a possibility.
            this.imagepath3 = 'assets/images/Worng.jpg';
            this.doctime = '';
          }
      }
    });


  }
  RetrivePO(){
    if(this.patientid == '' || this.patientid == null ){return;}
    this.nurseassessmentService.GetProgressStep(this.patientid, this.patdate,'PO').subscribe({
      next: (data: NurseAssessmentModel) => {
        if(data.nursetime !=null){
        this.imagepath4 = 'assets/images/Right.jpg';

        this.potime = formatDate(data.nursetime, 'hh:mm aa', 'en');
        }
      },
      complete: () => {
          if (!this.potime) {  // Check if visitlocation is undefined or null.  Could also check for an empty string "" if that's a possibility.
            this.imagepath4 = 'assets/images/Worng.jpg';
            this.potime = '';
          }
      }
    });


  }
  OpenPreparation() {
    this.storage.store('stgPatientCode',this.patientid);
//  this.storage.store('stgDoctorCode','');
    this.storage.store('stgDocumentDate',this.patdate);



  }
DataBankEntry(){
  this.storage.store('stgid',this.id);
  this.storage.store('stgDocumentDate',this.patdate);
  this.storage.store('stpatientname',this.patientname);

}
NursingEntry(){
  if(this.DisableNursing == true){return;}
        const dialogRef = this.dialogref.open(NursingAssessmentEntryComponent,
          {
            data: {
              dataKey: this.patientSelectedData,
              patientid : this.patientid,
              patientname : this.patientname,
              nursedate : this.patdate

            },
            width: '95vw',
            height: '35vw',
          });
        dialogRef.afterClosed().subscribe(result => {
          this.RetriveNurseAssessment()
        });

        const dialogSubmitSubscription =
          dialogRef.componentInstance.submitClicked.subscribe(result => {

            this.RetriveNurseAssessment()
            dialogSubmitSubscription.unsubscribe();
          });

}
DoctorObservation(){
  this.storage.store('stgPatientCode',this.patientid);
  this.storage.store('stgPatientName',this.patientname);
  this.storage.store('stgVisitDate',this.patdate);

}
UploadDocuments(){
  this.storage.store('stgPatientCode',this.patientid);

  this.storage.store('stgDocumentDate',this.patdate);
  this.storage.store('stpatientname',this.patientname);
}
  openRoundAndClinics (){
    this.storage.store('stgPatientCode',this.patientid);
  }

closedialog(){
  this.dialogref.closeAll();
}
}
